import axios from "axios";
import { instance, instancePolicy } from "../network/ApiCall";

export async function fetchEPoliciesMrise(type: string) {
  const response = await instance.get(`/ethics/mrise/policy?type=${type}`);
  return response.data;
}
export async function fetchEPolicies(data: any) {
  const response = await instance.get(`/ethics/policy?companyId=${data}}`);
  return response.data;
}
export async function fetchInsertPolicy(data: any) {
  const response = await instance.post("/ethics/policy", data);
  return response.data;
}
export async function fetchUpdatePolicy(data: any) {
  const response = await instance.put("/ethics/policy", data);
  return response.data;
}
export async function fetchDeletePolicy(data: any) {
  const response = await instance.delete(`/ethics/policy/${data}`);
  return response.data;
}
